const locale = {
	ABSSEARCH_TOOLTIP: 'Schnellsuche',
	ABSSEARCH_NORESULTS: 'Keine Suchergebnisse',
	ABSSHORTCUTS_TOOLTIP: 'Favoriten verwalten',
	ABSSHORTCUTS_SEARCH_TOOLTIP: 'Suche nach einer App oder einer Seite',
	LOADINGDOTDOTDOT: "Lade Inhalte...",
	CLOSE: "Schließen",
	NOSELECTION: "Keine Auswahl",
	ATTENTION: "Achtung",
	USAGEONMOBILEVIEWLIMITED: "Diese App ist noch nicht vollständig für die Benützung auf Mobilgeräten optimiert und es können eventuell visuelle Einschränkungen auftreten. Wir bitten um Ihr Verständnis.",
	DONTSHOWAGAIN: "Nicht mehr anzeigen",
};

export default locale;
